/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCcMastercard = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 19.999V4H2v15.999zM10 7.998c.565 0 1.101.12 1.588.331-1.229.81-1.988 2.189-1.988 3.669s.759 2.858 1.988 3.669A4 4 0 1 1 10 7.998zm2.412.331a4 4 0 1 1 0 7.338 4.41 4.41 0 0 0 1.988-3.669c0-1.48-.76-2.859-1.988-3.669zM14 11.998a3.998 3.998 0 0 1-2 3.465c-1.196-.692-2-1.985-2-3.465s.804-2.773 2-3.465c1.196.692 2 1.985 2 3.465z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCcMastercard as CcMastercard };
